var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoMiniMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 5,
    fill: "#27AE60",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.6 42V18.96H14.528V42H9.6ZM24.512 42V18.96H29.44V42H24.512ZM11.904 28.112H26.752V31.888H11.904V28.112ZM36.6633 42V38.48H42.6153C43.6819 38.48 44.4819 38.192 45.0153 37.616C45.5699 37.0187 45.8473 36.1973 45.8473 35.152C45.8473 34.0853 45.5486 33.2427 44.9513 32.624C44.3753 32.0053 43.5433 31.696 42.4553 31.696H36.6633V28.176H42.1993C43.2019 28.176 43.9593 27.9413 44.4713 27.472C45.0046 26.9813 45.2713 26.2667 45.2713 25.328C45.2713 24.3893 45.0153 23.6853 44.5033 23.216C44.0126 22.7253 43.2766 22.48 42.2953 22.48H36.6633V18.96H43.3513C45.3993 18.96 47.0526 19.4827 48.3113 20.528C49.5699 21.5733 50.1993 22.992 50.1993 24.784C50.1993 25.9147 49.9326 26.8853 49.3993 27.696C48.8659 28.5067 48.1513 29.1253 47.2553 29.552C46.3593 29.9787 45.3566 30.192 44.2473 30.192L44.4073 29.52C45.6019 29.52 46.6793 29.776 47.6393 30.288C48.6206 30.8 49.3993 31.5253 49.9753 32.464C50.5513 33.3813 50.8393 34.4693 50.8393 35.728C50.8393 36.9867 50.5406 38.096 49.9433 39.056C49.3673 39.9947 48.5459 40.72 47.4792 41.232C46.4339 41.744 45.1966 42 43.7673 42H36.6633ZM32.6313 42V18.96H37.5593V42H32.6313Z",
    fill: "#27AE60"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMiniMobile);
export default __webpack_public_path__ + "static/media/Logo-mini-mobile.a8488f88719923eb68aaf1e229ba272e.svg";
export { ForwardRef as ReactComponent };